import { render, staticRenderFns } from "./CreateRecipientsChooser.vue?vue&type=template&id=8c5101de"
import script from "./CreateRecipientsChooser.vue?vue&type=script&lang=js"
export * from "./CreateRecipientsChooser.vue?vue&type=script&lang=js"
import style0 from "./CreateRecipientsChooser.vue?vue&type=style&index=0&id=8c5101de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports